import React from 'react';
import ArticleField from '../ArticleField';
import { Switch } from '@material-ui/core';

interface SendToPartnerFeedProps {
    value: boolean,
    onChange: (value: boolean) => void
}

const SendToPartnerFeed = (props: SendToPartnerFeedProps) => (
    <ArticleField label="Envoyer au flux partenaires">
        <Switch checked={props.value} onChange={(e) => {
            props.onChange(e.target.checked);
        }} />
    </ArticleField >
)

export default SendToPartnerFeed;